module.exports = __webpack_public_path__ + "img/aParty_032523_J.2cdfd62f.jpg";